import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GirlIcon(props: IconProps) {
    return <Icon {...props} iconKey={"girl"}/>
}
